import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:localcoin": true
    });
  } catch (e) {}
}();
import clsx from 'clsx';
import React from 'react';
import { CloseIcon } from '@/public/assets/svg';
import RichText from '../RichText';
import { AlertBarProps } from './types';
const AlertBar: React.FC<AlertBarProps> = t0 => {
  const $ = _c(12);
  const {
    content,
    variant,
    onClose
  } = t0;
  const t1 = variant === "announcement";
  const t2 = variant === "alert";
  let t3;
  if ($[0] !== t1 || $[1] !== t2) {
    t3 = clsx("relative right-1/2 left-[calc(50%-4px)] ml-[-50vw] flex w-screen max-w-[100vw] px-8 py-3 text-center", {
      "bg-primary-500": t1,
      "bg-primary-650": t2
    });
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== content) {
    t4 = <div className="flex-1"><RichText field={content} data-sentry-element="RichText" data-sentry-source-file="index.tsx" /></div>;
    $[3] = content;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <CloseIcon className="h-6 w-6 transition-transform group-hover:scale-110" data-sentry-element="CloseIcon" data-sentry-source-file="index.tsx" />;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== onClose) {
    t6 = <button className="group" type="button" onClick={onClose}>{t5}</button>;
    $[6] = onClose;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t3 || $[9] !== t4 || $[10] !== t6) {
    t7 = <div className={t3} data-sentry-component="AlertBar" data-sentry-source-file="index.tsx">{t4}{t6}</div>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
};
export default AlertBar;